import { Card, Col, Row } from 'antd';
import React from 'react';
import { FunctionComponent } from 'react';
import { AiOutlineInfoCircle } from 'react-icons/ai';
import styled from 'styled-components';
import { BusinessStatuses } from '../../../../bank-components/business/table/data';
import FormUploads from '../../../../utils/FormUploads';
import style from './styles';
import { DocumentPageType, DocumentType, DocumentNameAndType } from './types';
const BusinessDocumentsWrapper = styled.div`
    ${style}
`;
interface BankAccountsProps {
    uploadFilesToBusinessAccount: (
        documentId: string,
        url: string,
        documentName: DocumentNameAndType | string,
        pageType: DocumentPageType,
        fileId: string,
        documentLabel?: string,
    ) => void;
    documents: any;
    docsArray: any[];
    errorObj: any;
    setUploadingObj: (val: any) => void;
    handleErrorFromDocsManager: (
        err: string,
        documentName: DocumentNameAndType | string,
        pageType?: DocumentPageType,
    ) => void;
    documentErrObj: any;
    activeData?: any;
}

const BankAccounts: FunctionComponent<BankAccountsProps> = ({
    uploadFilesToBusinessAccount,
    documents,
    docsArray,
    errorObj,
    setUploadingObj,
    handleErrorFromDocsManager,
    documentErrObj,
    activeData,
}: BankAccountsProps) => {
    const bankArray = docsArray.filter((val) => val.documentType == DocumentNameAndType.BANK_STATEMENT);
    if (bankArray.length == 0) return null;
    const bankAccountSettings = bankArray[0];
    const getErr = (documentName) => {
        return (
            errorObj[documentName]?.error ||
            documentErrObj[documentName]?.error ||
            documents[documentName]?.reasonForReturn
        );
    };
    const docsObj: any = {};
    docsArray?.map((val) => {
        docsObj[val?.documentType] = val;
    });
    if (bankAccountSettings?.years?.length == 0) return null;
    return (
        <BusinessDocumentsWrapper>
            <Card title="Bank / Wallet/ Biller Statements" className="card-wrapper  card-margin-top">
                <div className="card-description-wrapper">
                    <div className="card-description">
                        Upload the bank account statement{bankAccountSettings?.years?.length > 1 ? 's' : ''} for the
                        last {bankAccountSettings?.years?.length || 0} year
                        {bankAccountSettings?.years?.length > 1 ? 's' : ''}.
                    </div>
                    <AiOutlineInfoCircle size={16} className="info-icon" />
                </div>

                {bankAccountSettings?.years?.map((val, index) => (
                    <Row gutter={20} key={index}>
                        <Col span={24}>
                            <FormUploads
                                label={`Year ${val}${docsObj[val]?.isRequired ? '*' : ''}`}
                                formItemName={`bankyear${val}`}
                                documentConfig={{
                                    documentName: `${DocumentNameAndType.BANK_STATEMENT}_${val}`,
                                    documentType: DocumentType.KYC,
                                    pageType: DocumentPageType.STANDARD,
                                }}
                                getResponse={(response) => {
                                    if (response?.documentId) {
                                        uploadFilesToBusinessAccount(
                                            response?.documentId,
                                            response?.downloadURl,
                                            `${DocumentNameAndType.BANK_STATEMENT}_${val}`,
                                            DocumentPageType.STANDARD,
                                            response?.fileId,
                                        );
                                    } else {
                                        handleErrorFromDocsManager(
                                            response,
                                            `${DocumentNameAndType.BANK_STATEMENT}_${val}`,
                                            DocumentPageType.STANDARD,
                                        );
                                    }
                                }}
                                initialValue={documents[`${DocumentNameAndType.BANK_STATEMENT}_${val}`]?.['url']}
                                err={getErr(`${DocumentNameAndType.BANK_STATEMENT}_${val}`)}
                                validateStatus={
                                    getErr(`${DocumentNameAndType.BANK_STATEMENT}_${val}`) ? 'error' : 'success'
                                }
                                getFileStatus={(status) => {
                                    setUploadingObj((previousObj: any) => {
                                        if (status) {
                                            previousObj[`${DocumentNameAndType.BANK_STATEMENT}_${val}`] = true;
                                        } else {
                                            delete previousObj[`${DocumentNameAndType.BANK_STATEMENT}_${val}`];
                                        }
                                        return { ...previousObj };
                                    });
                                }}
                                required={docsObj[val]?.isRequired ?? false}
                                disabled={
                                    !getErr(`${DocumentNameAndType.BANK_STATEMENT}_${val}`) &&
                                    activeData?.status == BusinessStatuses.OnHold
                                }
                            />
                        </Col>
                    </Row>
                ))}
            </Card>
        </BusinessDocumentsWrapper>
    );
};

export default BankAccounts;
